module.exports = __webpack_public_path__ + "static/media/Reservation-01.5418f598.svg";